import { render, staticRenderFns } from "./PackageEditor.vue?vue&type=template&id=c5d9ba0a&scoped=true&"
import script from "./PackageEditor.vue?vue&type=script&lang=js&"
export * from "./PackageEditor.vue?vue&type=script&lang=js&"
import style0 from "./PackageEditor.vue?vue&type=style&index=0&id=c5d9ba0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d9ba0a",
  null
  
)

export default component.exports